<script>
import { map, isArray, isEmpty, find, uniq, join, head, sortBy } from "lodash";
import Cotizador from "./Cotizador.vue";

import carousel from "vue-owl-carousel";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  props: {
    url: { type: String, required: true },
    circuito: { type: Object, required: true },
    mes: { type: String, default: '' },
    showConector: { type: Boolean, required: true },
  },
  components: { Cotizador, carousel, CoolLightBox },
  data() {
    return {
      fotosShow: null,
      show: {
        detalle: true,
        itinerario: true,
        incluye: false,
        noIncluye: false,
        hoteles: false,
        observaciones: false,
      },
    };
  },
  computed: {
    /** General */
    id() {
      return this.circuito.CircuitoId;
    },
    codigo() {
      return this.circuito.CircuitoCodigo;
    },
    nombre() {
      return this.circuito.CircuitoNombre;
    },
    catalogo() {
      return this.circuito.CatalogoNombre;
    },
    operador() {
      return this.circuito.OperadorNombreComercial;
    },
    detalle() {
      return this.circuito.CircuitoNotas;
    },

    /** Fotos */
    isFotos() {
      return (
        isArray(this.circuito.CircuitoImagen) &&
        !isEmpty(this.circuito.CircuitoImagen)
      );
    },
    fotos() {
      return this.isFotos
        ? map(this.circuito.CircuitoImagen, (foto) => {
            return {
              src: foto.CircuitoImagenPath
                ? foto.CircuitoImagenPath
                : `data:image/png;base64,${foto.CircuitoImagenBlodBase64}`,
              title: foto.CircuitoImagenNombre,
            };
          })
        : false;
    },
    foto() {
      if (this.isFotos) {
        const foto = find(this.circuito.CircuitoImagen, {
          CircuitoImagenPrincipal: true,
          CircuitoImagenesEsPrincipal: "Principal",
        });
        if (foto) {
          return foto.CircuitoImagenPath
            ? foto.CircuitoImagenPath
            : `data:image/png;base64,${foto.CircuitoImagenBlodBase64}`;
        }
      }
      return false;
    },

    /** Duraciones */
    duracion() {
      return this.circuito.CircuitoDuracion;
    },

    /** Itinerario */
    origen() {
      if (
        isArray(this.circuito.CircuitoItinerario) &&
        !isEmpty(this.circuito.CircuitoItinerario)
      ) {
        const dia = head(this.circuito.CircuitoItinerario);
        const segmento = head(dia.Segmento);
        const ciudad = head(segmento.CircuitoItinSegPaisCiudad);
        return `${ciudad.CircuitoItinerarioSegCiudadNombre}, ${ciudad.CircuitoItinerarioSegPaisNombre}`;
      }
      return false;
    },
    ciudades() {
      if (
        isArray(this.circuito.CircuitoItinerario) &&
        !isEmpty(this.circuito.CircuitoItinerario)
      ) {
        const ciudades = [];

        this.circuito.CircuitoItinerario.forEach((item) => {
          item.ItinerarioCiudad.forEach((ciudad) => {
            ciudades.push(ciudad.CCiudadOtrasCiudadesNombre);
          });
        });
        return join(uniq(ciudades), " -");
      }

      return false;
    },
    itinerario() {
      if (
        isArray(this.circuito.CircuitoItinerario) &&
        !isEmpty(this.circuito.CircuitoItinerario)
      ) {
        return map(this.circuito.CircuitoItinerario, (item) => {
          return {
            id: item.CircuitoItinerarioId,
            titulo: item.CircuitoItinerarioNombreESP,
            dias: sortBy(
              map(item.Segmento, (segmento) => {
                let origen = false;

                if (segmento.CircuitoItinerarioSegCiudadSalida !== "") {
                  origen = segmento.CircuitoItinerarioSegCiudadSalida;
                  origen = origen.split(" - ");
                  origen.shift();
                  origen = origen.join(" - ");
                }

                return {
                  id: segmento.CircuitoItinerarioGuardaSegId,
                  dia: segmento.CircuitoItinerarioSegDia,
                  titulo: segmento.CircuitoItinerarioSegTitulo,
                  detalle: segmento.CircuitoItinerarioSegDesc,
                  comidas: {
                    desayuno: segmento.CircuitoItinerarioSegDesayuno,
                    almuerzo: segmento.CircuitoItinerarioSegAlmuerzo,
                    merienda: segmento.CircuitoItinerarioSegMerienda,
                    cena: segmento.CircuitoItinerarioSegCena,
                  },
                  origen: origen,
                  destinos: origen
                    ? false
                    : join(
                        map(segmento.CircuitoItinSegPaisCiudad, (ciudad) => {
                          return `${ciudad.CircuitoItinerarioSegCiudadNombre}, ${ciudad.CircuitoItinerarioSegPaisNombre}`;
                        }),
                        " - "
                      ),
                };
              }),
              "dia"
            ),
          };
        });
      }
      return false;
    },

    servicios() {
      if (isArray(this.circuito.Servicio) && !isEmpty(this.circuito.Servicio)) {
        return map(this.circuito.Servicio, (servicio) => {
          return { id: servicio.CServicioId, nombre: servicio.CServicioNombre };
        });
      }
      return false;
    },
    incluye() {
      if (
        isArray(this.circuito.CircuitoParametro) &&
        !isEmpty(this.circuito.CircuitoParametro)
      ) {
        return join(
          map(this.circuito.CircuitoParametro, (param) => {
            return param.CircuitoParametroIncluido;
          })
        );
      }
      return false;
    },

    noIncluye() {
      if (
        isArray(this.circuito.CircuitoParametro) &&
        !isEmpty(this.circuito.CircuitoParametro)
      ) {
        return join(
          map(this.circuito.CircuitoParametro, (param) => {
            return param.CircuitoParametroNoIncluido;
          })
        );
      }
      return false;
    },

    hoteles() {
      if (
        isArray(this.circuito.CircuitoParametro) &&
        !isEmpty(this.circuito.CircuitoParametro)
      ) {
        const hoteles = [];

        this.circuito.CircuitoParametro.forEach((param) => {
          param.Categoria.forEach((categoria) => {
            if (!isEmpty(categoria.Hotel)) {
              hoteles.push({
                id: categoria.CircuitoCategoriaId,
                nombre: categoria.CircuitoCategoriaNombre,
                hoteles: map(categoria.Hotel, (hotel) => {
                  return {
                    id: hotel.HotelHomologadoId,
                    ciudad: hotel.HotelHomologadoCiudadNombre,
                    hotel: hotel.HotelHomologadoRazonSocial,
                  };
                }),
              });
            }
          });
        });

        return hoteles;
      }
      return false;
    },

    observaciones() {
      if (
        isArray(this.circuito.CircuitoRemarks) &&
        !isEmpty(this.circuito.CircuitoRemarks)
      ) {
        return map(this.circuito.CircuitoRemarks, (remark) => {
          return {
            id: remark.CircuitoRemarksId,
            titulo: remark.CircuitoRemarksNombre,
            detalle: remark.CircuitoRemarksDescripcion,
            periodo: join(
              map(remark.Periodo, (periodo) => {
                const desde = periodo.CircuitoRemarksPeriodoDesde;
                const hasta = periodo.CircuitoRemarksPeriodoHasta;
                return `Aplica ${desde} / ${hasta}`;
              })
            ),
          };
        });
      }
      return false;
    },

    /** Tags */
    isTags() {
      return isArray(this.circuito.Tags) && !isEmpty(this.circuito.Tags);
    },
    tags() {
      return this.isTags
        ? map(this.circuito.Tags, (tag) => {
            return { id: tag.TagsId, nombre: tag.TagsNombre };
          })
        : false;
    },
  },
};
</script>

<template>
  <div class="container ficha">
    <div class="page-header page-header-title">
      <h3 v-html="nombre"></h3>
      <share-button
        :url="`${url}/services/inventory/${circuito.EmpresaMayoristaId}-${circuito.CircuitoId}?mes=${mes.slice(0, 7)}`"
        :title="nombre"
      ></share-button>
      <a
        class="pdf-button btn btn-primary"
        target="_blank"
        :href="`${url}/services/inventory/pdf/${circuito.EmpresaMayoristaId}-${circuito.CircuitoId}`"
      >
        <i class="fa fa-download"></i>
        PDF
      </a>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-9">
        <div class="panel panel-default panel-principal">
          <div class="row row-0">
            <div class="col-xs-12 col-sm-4" v-if="isFotos">
              <div
                class="img-bg"
                :style="{ backgroundImage: `url('${foto}')` }"
              ></div>
            </div>
            <div class="col-xs-12" :class="{ 'col-sm-8': isFotos }">
              <div class="panel-body">
                <ul class="list-unstyled">
                  <li v-if="codigo">
                    <b v-html="'C&oacute;digo:'"/>
                    <span v-html="codigo"/>
                  </li>
                  <li v-if="duracion">
                    <b v-html="'Duraci&oacute;n:'"/>
                    <span v-html="duracion"/>
                  </li>
                  <li v-if="catalogo">
                    <b v-html="'Cat&aacute;logo:'"/>
                    <span v-html="catalogo"/>
                  </li>
                  <li v-if="origen">
                    <b v-html="'Origen:'"/>
                    <span v-html="origen"/>
                  </li>
                  <li v-if="ciudades">
                    <b v-html="'Ciudades:'"/>
                    <span v-html="ciudades"/>
                  </li>
                  <li v-if="operador && showConector">
                    <b><i class="fa fa-user">&nbsp;</i>Operador: </b>
                    <span v-html="operador"/>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="fotos" v-if="isFotos">
          <CoolLightBox
            :items="fotos"
            :index="fotosShow"
            @close="fotosShow = null"
          >
          </CoolLightBox>
          <carousel :autoplay="true" :nav="false" :margin="10">
            <a
              v-for="(foto, key) in fotos"
              :key="key"
              class="img-thumbnail"
              :href="`#foto${key}`"
              @click="fotosShow = key"
            >
              <div
                :style="{ backgroundImage: `url('${foto.src}')` }"
                class="img-bg"
                :title="foto.title"
              ></div>
            </a>
          </carousel>
        </div>

        <div v-if="detalle">
          <div class="page-header">
            <i class="mdi mdi-information-outline"></i>
            <h4>Detalle</h4>
            <btn type="link" @click="show.detalle = !show.detalle">
              <i
                class="mdi"
                :class="show.detalle ? 'mdi-chevron-up' : 'mdi-chevron-down'"
              ></i>
            </btn>
          </div>

          <collapse v-model="show.detalle">
            <div class="panel panel-default">
              <div class="panel-body" v-html="detalle"></div>
            </div>
          </collapse>
        </div>

        <div v-if="itinerario" class="itinerario">
          <div class="page-header">
            <i class="mdi mdi-compass"></i>
            <h4>Itinerario</h4>
            <btn type="link" @click="show.itinerario = !show.itinerario">
              <i
                class="mdi"
                :class="show.itinerario ? 'mdi-chevron-up' : 'mdi-chevron-down'"
              ></i>
            </btn>
          </div>

          <collapse v-model="show.itinerario">
            <div
              class="panel panel-default"
              v-for="segmento in itinerario"
              :key="segmento.id"
            >
              <div class="list-group">
                <div
                  class="list-group-item"
                  v-for="dia in segmento.dias"
                  :key="`${segmento.id}_${dia.dia}`"
                >
                  <h4 class="list-group-item-heading">
                    <small v-html="`D&iacute;a ${dia.dia}`"></small>
                    <span v-html="dia.titulo"></span>
                  </h4>
                  <div class="list-group-item-text" v-html="dia.detalle"></div>

                  <ul class="list-inline">
                    <li v-if="dia.origen">
                      <b>Origen:</b>
                      <i class="fa fa-map-marker" aria-hidden="true"></i>
                      <span v-html="dia.origen"></span>
                    </li>
                    <li v-if="dia.destinos">
                      <b>Destinos:</b>
                      <i class="fa fa-map" aria-hidden="true"></i>
                      <span v-html="dia.destinos"></span>
                    </li>
                  </ul>

                  <ul class="list-inline">
                    <li
                      v-if="
                        dia.comidas.desayuno ||
                          dia.comidas.almuerzo ||
                          dia.comidas.merienda ||
                          dia.comidas.cena
                      "
                    >
                      <b>Comidas:</b>
                    </li>
                    <li v-if="dia.comidas.desayuno">
                      <i class="mdi mdi-coffee" title="Desayuno"></i>
                      Desayuno
                    </li>
                    <li v-if="dia.comidas.almuerzo">
                      <i class="mdi mdi-hamburger" title="Almuerzo"></i>
                      Almuerzo
                    </li>
                    <li v-if="dia.comidas.merienda">
                      <i class="mdi mdi-food-croissant" title="Merienda"></i>
                      Merienda
                    </li>
                    <li v-if="dia.comidas.cena">
                      <i class="mdi mdi-pasta" title="Cena"></i>
                      Cena
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </collapse>
        </div>

        <div v-if="incluye">
          <div class="page-header">
            <i class="mdi mdi-check-circle"></i>
            <h4>Incluye</h4>
            <btn type="link" @click="show.incluye = !show.incluye">
              <i
                class="mdi"
                :class="show.incluye ? 'mdi-chevron-up' : 'mdi-chevron-down'"
              ></i>
            </btn>
          </div>
          <collapse v-model="show.incluye">
            <div class="panel panel-default">
              <div class="panel-body">
                <ul class="list-inline" v-if="servicios">
                  <li v-for="servicio in servicios" :key="servicio.id">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                    <span v-html="servicio.nombre"></span>
                  </li>
                </ul>
                <div v-html="incluye"></div>
              </div>
            </div>
          </collapse>
        </div>

        <div v-if="noIncluye">
          <div class="page-header">
            <i class="mdi mdi-close-circle"></i>
            <h4>No incluye</h4>
            <btn type="link" @click="show.noIncluye = !show.noIncluye">
              <i
                class="mdi"
                :class="show.noIncluye ? 'mdi-chevron-up' : 'mdi-chevron-down'"
              ></i>
            </btn>
          </div>
          <collapse v-model="show.noIncluye">
            <div class="panel panel-default">
              <div class="panel-body" v-html="noIncluye"></div>
            </div>
          </collapse>
        </div>

        <div v-if="hoteles">
          <div class="page-header">
            <i class="mdi mdi-bed"></i>
            <h4>Hoteles Previstos</h4>
            <btn type="link" @click="show.hoteles = !show.hoteles">
              <i
                class="mdi"
                :class="show.hoteles ? 'mdi-chevron-up' : 'mdi-chevron-down'"
              ></i>
            </btn>
          </div>

          <collapse v-model="show.hoteles">
            <div class="panel panel-default">
              <table class="table table-bordered">
                <tbody>
                  <template v-for="categoria in hoteles">
                    <tr :key="categoria.id" class="active">
                      <th colspan="2" v-html="categoria.nombre"></th>
                    </tr>
                    <tr v-for="hotel in categoria.hoteles" :key="hotel.id">
                      <th v-html="hotel.ciudad"></th>
                      <td v-html="hotel.hotel"></td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </collapse>
        </div>

        <div v-if="observaciones">
          <div class="page-header">
            <i class="mdi mdi-alert-circle"></i>
            <h4>Observaciones</h4>
            <btn type="link" @click="show.observaciones = !show.observaciones">
              <i
                class="mdi"
                :class="
                  show.observaciones ? 'mdi-chevron-up' : 'mdi-chevron-down'
                "
              ></i>
            </btn>
          </div>

          <collapse v-model="show.observaciones">
            <div class="list-group">
              <div
                class="list-group-item"
                v-for="observacion in observaciones"
                :key="observacion.id"
              >
                <h4
                  class="list-group-item-heading"
                  v-html="observacion.titulo"
                ></h4>
                <div class="list-group-item-text">
                  <div v-html="observacion.detalle"></div>
                  <b class="text-muted" v-html="observacion.periodo"></b>
                </div>
              </div>
            </div>
          </collapse>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4 col-md-3">
        <cotizador :url="url" :circuito="circuito" :mes="mes"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.ficha {
  padding-top: 20px;
  padding-bottom: 20px;

  .img-bg {
    width: 100%;
    height: 100%;
    background: no-repeat center;
    background-size: cover;
  }

  .panel-principal {
    > .row {
      display: flex;

      > div {
        .panel-body {
          min-height: 170px;

          .list-unstyled {
            font-size: 13px;
            line-height: 20px;
            margin-bottom: 0px;
          }
        }
      }
    }
  }

  .fotos {
    .img-thumbnail {
      width: 100%;
      .img-bg {
        height: 200px;
      }
    }
  }

  .panel {
    > .panel-body {
      > p:last-child {
        margin-bottom: 0px;
      }
    }
  }

  .itinerario {
    .panel > .list-group > .list-group-item > .list-inline {
      margin-bottom: 0px;
    }
  }

  > .row > div .page-header {
    position: relative;
    padding: 0px 40px 10px 40px;

    > .mdi {
      width: 30px;
      height: 35px;
      font-size: 30px;
      line-height: 35px;
      margin-right: 10px;
      position: absolute;
      left: 0px;
      top: -9px;
      color: #afafaf;
    }
    > h4 {
      margin: 7px 0;
      font-size: 20px;
    }
    > button {
      width: 40px;
      height: 35px;
      font-size: 25px;
      padding: 5px 5px;
      line-height: 20px;
      position: absolute;
      top: -6px;
      right: 0;
    }
  }
}
</style>
